import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_VDAY_65: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_VDAY_65,
  },
  {
    pageId: PageId.CHAT_UPSELL_VDAY_65,
  },
  {
    pageId: PageId.UPSELL_VDAY_65,
  },
  {
    pageId: PageId.DOWNLOAD_VDAY_65,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
